// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "stylesheets/" + chunkId + "." + {"166":"6bd4217bb1","585":"5613aa4f26"}[chunkId] + ".min.css";
};